import { getEntryProps } from '../utils/getEntryProps.js';
import { mapEntryLink, mapLinkGroup } from './navlink.js';
const mapFooterProps = footer => {
  const _getEntryProps = getEntryProps(footer, {}),
    socialMediaLinks = _getEntryProps.socialMediaLinks,
    columnOne = _getEntryProps.columnOne,
    columnTwo = _getEntryProps.columnTwo,
    columnThree = _getEntryProps.columnThree;
  const mappedFooterSocialMediaLinks = socialMediaLinks?.map(mapEntryLink);
  return {
    socialMediaLinks: mappedFooterSocialMediaLinks || [],
    columnOne: columnOne?.map(mapLinkGroup) || [],
    columnTwo: columnTwo?.map(mapLinkGroup) || [],
    columnThree: columnThree?.map(mapLinkGroup) || []
  };
};
export { mapFooterProps };
//# sourceMappingURL=footer.js.map
